import axios from '@/js/lib/helper/axios';
import { updateToken } from '@/js/lib/api/update_token';

export interface UnsubscribeData {
  email: string;
}

export const unsubscribe = async ({ email }: UnsubscribeData): Promise<''> => {
  const token = await updateToken();
  const res = await axios.delete('/api/unsubscribe/newsletter', {
    params: {
      email,
      token,
    },
  });
  return res.data;
};
